export enum SearchCriteriaFieldName {
  ENROLLMENT_STATUS = "searchFetchType",
  PARTICIPANT_NAME = "name",
  ORGANIZATION_NAME = "organizationName",
  JOB_TITLE = "jobTitle",
  WORK_EMAIL = "workEmail",
  CONFIRMATION_NUMBER = "confirmationNumber",
  PARTICIPANT_TYPE = "attendeeParticipantTypeId",
  PARTICIPANT_SUB_ROLE = "participantSubRoles",
  PARTICIPANT_TAG = "tags",
  PREFIX = "prefix"
}
